
import {getListOrganization} from '../api/getListOrganization';
import {setGetListOrganizationAction} from '../action';

const setGetListOrganization = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListOrganization(params);
            if (data.status === 'success') {
                dispatch(setGetListOrganizationAction(data.data));           
            }
    
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListOrganization
}